import { Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import { handleFieldChange } from "../../Utils";
import { Component } from 'react';

import React from 'react';

import SelectWrap from "../../components/SelectWrap";
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import API from "../../services/API";

import History from "./components/History";
import Form from "./components/Form";

class DomainsV2 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            values: {
                types: [],
                domains: [],
            },
            filters: {
                type_id: []
            },
            form: null,
            history: null,
        };

        this.submit = this.submit.bind(this);
        this.refresh = this.refresh.bind(this);
        this.history = this.history.bind(this);
        this.remove = this.remove.bind(this);
        this.handleFieldChange = handleFieldChange.bind(this);
    }

    componentDidMount() {
        this.refresh().catch(console.error);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(prevState.filters) !== JSON.stringify(this.state.filters)) {
            return this.refresh();
        }
    }

    async refresh() {
        this.setState({ loading: true });

        const state = this.state;

        const filters = {
            type_id: this.state.filters.type_id
        }

        if (filters.type_id) {
            const map = this.state.values.types.reduce((object, row) => (object[row.type] = row.id, object), {})

            filters.type_id = filters.type_id.map((type) => map[type]);
        }

        state.values.domains = await API.DomainsV2.get(filters);
        state.values.types = await API.DomainsV2.types();

        this.setState({ ...state, loading: false });
    }

    async submit(form) {
        form.id ? await API.DomainsV2.update(form) : await API.DomainsV2.save(form);

        this.setState({ form: null });

        await this.refresh();
    }

    async history(domain) {
        this.setState({ ...this.state, history: domain });
    }

    async remove(row) {
        if (!window.confirm(`Are you sure to delete "${row.domain}" (${[ row.type, row.hour ].filter(Boolean).join(' - ')})`)) return;

        if (row.id) {
            await API.DomainsV2.remove(row.id);

            await this.refresh();
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Domains V2"/>

                <Row>
                    <Col lg={3}>
                        <SelectWrap
                            values={this.state.values.types.map((x) => x.type)}
                            label="Types:"
                            name="filters.type_id"
                            onChange={this.handleFieldChange}
                            value={this.state.filters.type_id}
                            multi
                        />
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <ButtonGroup className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={() => this.setState({ form: {} })}>Create</Button>
                        </ButtonGroup>
                    </Col>
                </Row>

                { this.state.form && <Form close={() => this.setState({ form: null })} form={this.state.form} types={this.state.values.types} submit={this.submit} />}
                { this.state.history && <History close={() => this.setState({ history: null })} domain={this.state.history} />}

                <Table data={this.state.values.domains} edit={(row) => this.setState({ form: row })} remove={this.remove} history={this.history} />
            </Container>
        );
    }
}

export default DomainsV2;



// WEBPACK FOOTER //
// ./src/scenes/DomainsV2/index.js